module.exports = __webpack_public_path__ + "static/media/logo_sh-netz.de16588b.png";